<template>
  <div class="bg-base-800 flex items-center justify-center rounded-full">
    <svg
      class="h-2/5 w-2/5"
      fill="none"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.9993 32.0002C39.3631 32.0002 45.3327 26.0306 45.3327 18.6668C45.3327 11.303 39.3631 5.3335 31.9993 5.3335C24.6356 5.3335 18.666 11.303 18.666 18.6668C18.666 26.0306 24.6356 32.0002 31.9993 32.0002Z"
        stroke="currentcolor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="4"
      />
      <path
        d="M54.9071 58.6667C54.9071 48.3467 44.6404 40 32.0004 40C19.3604 40 9.09375 48.3467 9.09375 58.6667"
        stroke="currentcolor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="4"
      />
    </svg>
  </div>
</template>
